import { Rows } from "../../components/Rows";
import { useConfig } from "../../hooks/useConfig";
import { AT_LAUNCH, PROMOTION_FALLBACK } from "../../lib/facts";
import { creatorShare, tradersPay } from "../../lib/fees";
import { addressUrl, ROBINHOOD_EXPLORER_URL } from "../../wallets/chain";

/**
 * What the team holds, what it was paid, and what the fees are. Every value
 * comes from the server, so a blank is a blank and never a guess.
 */
export function Disclosures() {
  const { config } = useConfig();
  const explorerUrl = config?.explorerUrl ?? ROBINHOOD_EXPLORER_URL;
  const wallet = config?.team.wallet ?? null;
  const devBuyNote = config?.team.devBuyNote ?? null;
  const burnTx = config?.team.burnTx ?? null;
  const poolNote = config?.pool.note ?? null;
  const promotion = config?.team.promotion ?? PROMOTION_FALLBACK;

  return (
    <div className="stack stack-4">
      <h4>Disclosures</h4>
      <div className="card card--sunken">
        <Rows
          items={[
            {
              key: "wallet",
              label: "Creator wallet",
              stack: true,
              value: wallet ? (
                <a
                  className="mono"
                  href={addressUrl(explorerUrl, wallet)}
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  {wallet}
                </a>
              ) : (
                AT_LAUNCH
              ),
            },
            {
              key: "dev-buy",
              label: "Developer buy",
              stack: true,
              value: devBuyNote ?? AT_LAUNCH,
            },
            {
              key: "burn",
              label: "Burn",
              stack: true,
              value: burnTx ? (
                <a className="mono" href={`${explorerUrl}/tx/${burnTx}`} target="_blank" rel="noreferrer noopener">
                  {burnTx}
                </a>
              ) : (
                "none recorded"
              ),
            },
            { key: "pool", label: "Airdrop pool", stack: true, value: poolNote ?? "published once it is funded" },
            { key: "promotion", label: "Promotion", stack: true, value: promotion },
            { key: "fee", label: "Trading fee", value: tradersPay(config) },
            { key: "creator", label: "Creator's share", value: creatorShare(config) },
          ]}
        />
      </div>
      <p className="tiny">
        The developer buy, what happened to it, the airdrop pool and the creator wallet are listed
        above from the server. If a number is missing it has not happened yet.
      </p>
    </div>
  );
}
